import { defaultApi } from '@/api';
import { FieldType } from '@/features/canvas/types/field-type';
import { components } from '@/types/api';

type Hyperlink = components['schemas']['Hyperlink'];

export async function getHyperlinksByField({
  field_id,
  field_type,
}: {
  field_id: number;
  field_type: FieldType;
}): Promise<Hyperlink[]> {
  const { data } = await defaultApi.get('/hyperlinks', {
    params: { field_id, field_type },
  });
  return data.hyperlinks;
}

export async function createHyperlink(payload: {
  field_type: FieldType;
  field_id: number;
  url: string;
  display_text?: string;
  position_start?: number;
  position_end?: number;
}): Promise<Hyperlink> {
  const { data } = await defaultApi.post('/hyperlinks', payload);
  return data.hyperlink;
}

export async function updateHyperlink(hyperlinkId: number, payload: {
  url: string;
  display_text?: string;
  position_start?: number;
  position_end?: number;
}): Promise<Hyperlink> {
  const { data } = await defaultApi.patch(`/hyperlinks/${hyperlinkId}`, payload);
  return data.hyperlink;
}

export async function deleteHyperlink(hyperlinkId: number) {
  await defaultApi.delete(`/hyperlinks/${hyperlinkId}`);
}

/* To be deleted when full Hyperlinks (Sections and Time Periods) is implemented */
export async function updateHyperlinks(payload: {
  field_type: FieldType;
  field_id: number;
  hyperlinks: Hyperlink[];
}) {
  const { data } = await defaultApi.patch('/hyperlinks', payload);
}